import { render, staticRenderFns } from "./SnapshotContactForm.vue?vue&type=template&id=2d90c1a4"
import script from "./SnapshotContactForm.vue?vue&type=script&lang=js"
export * from "./SnapshotContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports